import { observer } from 'mobx-react';
import * as React from 'react';
import ProgramStore from '../../../ProgramStore';
import { ActiveProgram, CoachingProductDetails } from '../../../ProgramStore/Types';
import * as style from '../../Dashboard/style.module.css';
import ModalStore from '../../Modal/Store';
import Orientation from './Orientation';
import OrientationModal from './Orientation/OrientationModal';

interface Props {
  activeProgram: ActiveProgram;
  store: ProgramStore;
  coachingProductDetails: CoachingProductDetails;
}

class ActiveCoachingProductOverview extends React.Component<Props, {}> {
  modalStore = new ModalStore();

  render() {
    const { store, activeProgram, coachingProductDetails } = this.props;

    const content = (
      <>
        <OrientationModal modalStore={this.modalStore} programStore={store} />
        <Orientation
          programStore={store}
          modalStore={this.modalStore}
          activeProgram={activeProgram}
          coachingProductDetails={coachingProductDetails}
        />
      </>
    );

    // After orientation the card draws its own dashboard card frame.
    switch (coachingProductDetails.orientationStatus) {
      case 'Completed':
        return content;
      case 'Unstarted':
      case 'Started':
      case 'NotApplicable':
        return (
          <div className={style.program} data-test-active-program={true}>
            {content}
          </div>
        );
    }
  }
}

export default observer(ActiveCoachingProductOverview);
